const getDaysInMonth = (year: number, month: number) => {
    return new Date(year, month + 1, 0).getDate();
}

const millsecondsInMinute = 60000;

export const addMonths = (date: Date, value: number) => {
    if (!value) {
        return date;
    }

    const d = new Date(date),
        n = date.getDate();
    d.setDate(1);
    d.setMonth(d.getMonth() + value);
    d.setDate(Math.min(n, getDaysInMonth(d.getFullYear(), d.getMonth())));

    return d;
};

export const getLocalizedDate = (date: Date) => {
    const currentDate = new Date();

    return new Date(date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        currentDate.getHours(),
        currentDate.getMonth(),
        currentDate.getMinutes());
};

export const parseUtcDate = (dateRerp: any): Date => {
    const date = new Date(dateRerp);

    return new Date(date.getTime() - date.getTimezoneOffset() * millsecondsInMinute);
};

export const getWithoutTime = (date: Date) => {
    date = new Date(date);
    date.setHours(0, 0, 0, 0);
    return date;
};

export const getShortDateString = (date: Date) => {
    const dateInp = new Date(date);
    return dateInp.toISOString().substr(0, 10);
};